module.exports = __webpack_public_path__ + "img/yourmic-v2.82e7f5ee.png";